export default __webpack_public_path__ + "static/media/File4.ae5a0236.pdf";